import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { COMPANY } from "@/lib/data";

const SiteContext = createContext(null);

const DEFAULTS = {
  phone: COMPANY.phone,
  email: COMPANY.email,
  website: COMPANY.website,
  office_hours: "Monday – Friday: 6:00 AM – 6:00 PM\nSaturday: 7:00 AM – 3:00 PM\nSunday: Closed",
  hero_headline: "Reliable Rides. Compassionate Care. Every Time.",
  hero_subtext: COMPANY.name +
    " provides safe, reliable, and compassionate non-emergency medical transportation throughout communities across Pennsylvania. Whether you need transportation to a medical appointment, treatment center, day program, or community activity, our team is here to help.",
  service_areas_heading: "Proudly Serving Communities Across Pennsylvania",
  service_areas_text:
    "CareDeserved provides transportation throughout counties across eastern and central Pennsylvania. We're always expanding — reach out to confirm availability in your area.",
  hero_image_id: "",
  facilities_image_id: "",
  care_image_id: "",
  nemt_image_id: "", wheelchair_image_id: "", ambulatory_image_id: "",
  odp_hab_image_id: "", odp_companion_image_id: "", odp_nursing_image_id: "", odp_video_image_id: "",
  hero_video_url: "", odp_video_url: "",
  social_facebook: "", social_instagram: "", social_linkedin: "", social_x: "", social_youtube: "",
  whatsapp_enabled: true,
  whatsapp_number: "+1 484-877-5855",
  whatsapp_username: "@caredeserved",
  whatsapp_prefill: "Hello CareDeserved, I'm contacting you through your website and would like assistance.",
  recruiting_enabled: true,
  recruiting_fulltime: true,
  recruiting_parttime: true,
  recruiting_counties: ["Delaware", "Chester", "Berks", "Bucks", "Northampton", "Lehigh", "Lebanon", "Lancaster", "York", "Schuylkill"],
  recruiting_headline: "Drivers Wanted",
  recruiting_description: "Join CareDeserved and help provide safe, reliable and compassionate transportation throughout Pennsylvania. Company transportation work in a professional, compassionate environment serving seniors, individuals with disabilities, and community members. Training provided where applicable.",
  recruiting_pay: "",
  recruiting_button_text: "Apply Today",
  recruiting_image_id: "",
  careers_hero_image_id: "",
  careers_requirements: "Dependable transportation professionals\nSafe driving habits\nProfessionalism and punctuality\nStrong, clear communication\nCompassion when working with seniors and individuals with disabilities\nWillingness to complete required screening and training",
  recruit_ticker_enabled: true,
  recruit_ticker_text: "CareDeserved Is Hiring! NEMT Drivers + ODP / Human Services Professionals — Full-Time, Part-Time & PRN Opportunities Available. View Open Positions & Apply Today",
};

export const mediaUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/media/${id}`;

export const phoneHref = (phone) => `tel:+1${(phone || "").replace(/[^0-9]/g, "")}`;

export const whatsappHref = (content) => {
  const digits = (content?.whatsapp_number || "").replace(/[^0-9]/g, "");
  const text = (content?.whatsapp_prefill || "").trim();
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export function SiteProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/content")
      .then((r) => setContent({ ...DEFAULTS, ...r.data }))
      .catch(() => setContent(DEFAULTS));
  }, []);

  return <SiteContext.Provider value={content}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext) || DEFAULTS;
}
